import React, { useContext } from 'react';
import { Modal, Button, ListGroup, Badge, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faMoneyBillWave, faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import AppContext from 'context/Context';

const getTipoIcon = (tipo) => {
    if (!tipo) return { icon: faFileInvoice, color: '#6c757d', label: '' };
    const t = tipo.toString().toLowerCase();
    if (t.includes('ing') || t === 'i' || t.includes('ingreso')) return { icon: faArrowUp, color: '#28a745', label: 'Ingreso' };
    if (t.includes('egr') || t === 'e' || t.includes('egreso')) return { icon: faArrowDown, color: '#dc3545', label: 'Egreso' };
    if (t.includes('pag') || t === 'p' || t.includes('pago')) return { icon: faMoneyBillWave, color: '#0d6efd', label: 'Pago' };
    return { icon: faFileInvoice, color: '#6c757d', label: tipo };
};

const formatNumber = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const num = Number(value);
    if (isNaN(num)) return value;
    return num.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const SelectFacturaModal = ({
    show,
    onHide,
    facturas,
    selectedIndex,
    setSelectedIndex,
    onConfirm,
    title = 'Seleccionar factura'
}) => {
    const { config } = useContext(AppContext);
    const isDark = config.isDark;
    const hasFacturas = facturas && facturas.length > 0;

    return (
        <Modal show={show} onHide={onHide} centered size="lg" dialogClassName={isDark ? 'modal-dark' : ''}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!hasFacturas ? (
                    <div className="text-center py-5">
                        <FontAwesomeIcon icon={faFileInvoice} size="3x" className="text-muted mb-3" />
                        <p className="text-muted">No hay facturas disponibles</p>
                    </div>
                ) : (
                    <ListGroup variant="flush">
                        {facturas.map((f, idx) => {
                            const uuid = f?.vUUIDFactura || '';
                            const fecha = f?.dFechaEmision || '';
                            const activo = f?.bIsActive === 1 || f?.bIsActive === true;
                            const tipo = f?.vTipoComprobante || '';
                            const tipoInfo = getTipoIcon(tipo);
                            const total = f?.dTotal ?? '';
                            const moneda = f?.vMoneda || '';
                            const amountClass = tipoInfo.label === 'Ingreso' ? 'text-success fw-bold' : (tipoInfo.label === 'Egreso' ? 'text-danger fw-bold' : 'fw-bold');

                            return (
                                <ListGroup.Item
                                    key={idx}
                                    action
                                    active={selectedIndex === idx}
                                    onClick={() => setSelectedIndex(idx)}
                                    className="d-flex justify-content-between align-items-start"
                                    style={selectedIndex === idx ? { backgroundColor: isDark ? '#495057' : '#e3f2fd', color: isDark ? '#fff' : '#000' } : {}}
                                >
                                    <div className="ms-2 me-auto">
                                        <div className="d-flex align-items-center">
                                            <FontAwesomeIcon icon={tipoInfo.icon} style={{ color: tipoInfo.color }} className="me-2" />
                                            <div className="fw-bold text-break">{uuid}</div>
                                        </div>
                                        <div className="small text-muted">{fecha} {tipo && ` - ${tipoInfo.label || tipo}`}</div>
                                    </div>
                                    <div className="text-end">
                                        {!activo && <Badge bg="danger" pill className="mb-1">Cancelada</Badge>}
                                        <div className={amountClass}>
                                            {total !== '' ? `${formatNumber(total)} ${moneda}` : ''}
                                        </div>
                                        <div className="small text-muted">{f?.vRfcEmisor}</div>
                                    </div>
                                </ListGroup.Item>
                            );
                        })}
                    </ListGroup>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Row className="w-100">
                    <Col xs={6} className="text-start">
                        <Button variant="link" onClick={onHide}>Cancelar</Button>
                    </Col>
                    <Col xs={6} className="text-end">
                        <Button variant="primary" onClick={onConfirm} disabled={!hasFacturas}>Aceptar</Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};

SelectFacturaModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    facturas: PropTypes.array.isRequired,
    selectedIndex: PropTypes.number.isRequired,
    setSelectedIndex: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string
};

export default SelectFacturaModal;
